import "./ShiftsOverview.css";
import axios from "axios";
import {useState, useEffect, useRef} from "react";
import LoadingSpinner from "../../../../../sharedComponents/LoadingSpinner/LoadingSpinner";
import { Link } from "react-router-dom";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { Alert, Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Snackbar, useMediaQuery } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import CreateShiftModal from "./createShift/modal/CreateShiftModal";
import ScrollRecovery from "../../../../../sharedComponents/ScrollRecovery";
import { CustomProvider, DatePicker } from "rsuite";
import PrimaryButton from "../../../../../sharedComponents/primaryButton/PrimaryButton";
import { deDE } from "rsuite/esm/locales";
import calculateMonthWorkingTime from "./calculateMonthWorkingTime";

function isFutureMonth(date) {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return false;
    const now = new Date();
    return date.getFullYear() * 12 + date.getMonth() > now.getFullYear() * 12 + now.getMonth();
}

function hasIncompleteShifts(shifts) {
    return (shifts || []).some((shift) => {
        if (!shift) return false;
        return (
            shift.shift_status === "not_completed" ||
            shift.shift_status === "edited_not_completed" ||
            shift.has_unresolved_objections ||
            !shift.end_time ||
            !shift.duration_working
        );
    });
}

function getInitialSelectedMonth() {
    const storedMonth = localStorage.getItem("selectedMonthShift");
    const initialMonth = storedMonth ? new Date(storedMonth) : new Date();

    if (isFutureMonth(initialMonth)) {
        const currentMonth = new Date();
        localStorage.setItem("selectedMonthShift", currentMonth);
        return currentMonth;
    }

    return initialMonth;
}

function ShiftsOverview(props) {

    const [isLoading, setIsLoading] = useState(true);
    const [allShifts, setAllShifts] = useState([]);
    const [problemShifts, setProblemShifts] = useState([]);
    const [hasliveShift, setHasLiveShift] = useState("");
    const [open, setOpen] = useState([]);
    const [creationModalShow, setCreationModalShow] = useState(false);
    const matches = useMediaQuery('(min-width:550px)');

    const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);

    const [selectedMonth, setSelectedMonth] = useState(getInitialSelectedMonth);
    const [firstDayOfMonth, setFirstDayOfMonth] = useState("2025-08-01");
    const [lastDayOfMonth, setLastDayOfMonth] = useState("2025-08-31");    
    
    const monthListLength = useRef(0);   

    useEffect(() => {
        if(props.shiftIssue){
            const newDate = new Date();
            const newDateString = newDate.getFullYear() + '-' + timeFormatCheck(newDate.getMonth()+1) + '-' + timeFormatCheck(newDate.getDate());
            axios.get('shift/getByEmployeeIdInDuration?id=' + new URLSearchParams(window.location.search).get("employeeId") + '&start=2023-06-01&end=' + newDateString + '&sort=desc').then(results => {
                const allShifts = results.data;
                const filtered = allShifts.filter((shift) => 
                    shift.shift_status === "not_completed" ||
                    shift.has_unresolved_objections ||
                    shift.shift_status === "edited_not_completed"
                );
                setProblemShifts(filtered);
            });
        }       
        axios.get('shift/getByEmployeeIdInDuration?id=' + new URLSearchParams(window.location.search).get("employeeId") + '&start='+ firstDayOfMonth + '&end=' + lastDayOfMonth + '&sort=desc').then(results => {
            setAllShifts(results.data);
            setIsLoading(false);
        });
        axios.get('activity/getAllForOngoingShiftByEmployeeId?id=' + new URLSearchParams(window.location.search).get("employeeId")).then(results => {
            setHasLiveShift(results.data);
        });
    }, [isLoading, lastDayOfMonth, firstDayOfMonth, props.shiftIssue]);

    useEffect(() => {
        const newFirstDay = new Date(new Date(selectedMonth.getFullYear(), selectedMonth.getMonth(), 1));
        setFirstDayOfMonth(newFirstDay.getFullYear() + '-' + timeFormatCheck(newFirstDay.getMonth()+1) + '-' + timeFormatCheck(newFirstDay.getDate()));

        const newLastDay = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth()+1, 0);
        setLastDayOfMonth(newLastDay.getFullYear() + '-' + timeFormatCheck(newLastDay.getMonth()+1) + '-' + timeFormatCheck(newLastDay.getDate()));
    }, [selectedMonth])

    useEffect(() => {
        const storedOpenState = localStorage.getItem("openState");

        if(storedOpenState === null){
            const initialOpenState = Array(monthListLength).fill(false);
  
            // Set the first element (current month) to true
            initialOpenState[0] = true;

            setOpen(initialOpenState);
        } else {
            setOpen(JSON.parse(storedOpenState));
        }
    }, [monthListLength])

    const handleClick = (index) => {
        const newOpenState = [...open];
        newOpenState[index] = !newOpenState[index];
        setOpen(newOpenState);
        localStorage.setItem("openState", JSON.stringify(newOpenState));
    };

    function timeFormatCheck(number) {
        if (number < 10)
            return "0" + number;
        else
            return number;
    }

    function createMonths() {
        const monthsList = [];

        const monthString = selectedMonth.toLocaleDateString('de', {month: 'long', year: 'numeric'});
        monthsList.push(monthString);

        const monthRender = [];
        monthsList.forEach((item, index) => {
            monthRender.push(
                <div key={index}>
                    <ListItemButton onClick={() => handleClick(index)} >
                        <ListItemText primary= {item} />
                        <span className="month-working-time-summary">
                            {hasIncompleteShifts(allShifts)
                                ? "Summe nicht berechenbar – Zeiten sind offen"
                                : <>
                                    Arbeitszeit Gesamt:{" "}
                                    <span className="month-working-time-value">
                                        {calculateMonthWorkingTime(allShifts)}
                                    </span>
                                </>}
                        </span>
                        {open[index] ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={open[index]} timeout="auto" unmountOnExit>
                        <List>
                            {createShiftObjects(item)}
                        </List>
                    </Collapse>
                </div>
            )
        })

        monthListLength.current = monthsList.length;

        return monthRender;
    }

    function createDuration(hours, minutes) {
        if ((hours && minutes) !== null)
            return hours + ":" + timeFormatCheck(minutes) + " Std";
        else
            return "???";
    }

    function createListItemTextForShifts(date, startTime, endTime, isIgnored) {
        return <p>Arbeitszeit am {date}, {startTime} - {endTime} Uhr {} {isIgnored && <p className="red-color">Wird ignoriert</p>}</p>;
    }

    function createShiftObjects(monthName) {
        let shifts = [];

        if(hasliveShift){
            let liveShift = hasliveShift[0];
            let liveShiftTime = new Date(liveShift.timestamp);
            let monthString = liveShiftTime.toLocaleDateString('de', { month: 'long', year: 'numeric' });
            if(monthString === monthName){
                shifts.push(
                    <ListItem className="duration-pause-time" key={"live"} secondaryAction={matches &&
                        <ListItemText
                            primary={"Live-Arbeitszeit"}
                        />
                    }>
                        <ListItemButton sx={{ pl: 4 }} component={Link} to={"/home/employees/employeeView/shift?beginId=" + liveShift.id} shiftIssue={props.shiftIssue} >
                            <ListItemIcon>
                                <img src={process.env.PUBLIC_URL + '/icons/redCircle.png'} alt="" width={30} height={30} />
                            </ListItemIcon>
                            <ListItemText primary={"Arbeitszeit am " + liveShiftTime.toLocaleDateString('de', { year: "numeric", month: "2-digit", day: "2-digit" }) + ", " + liveShiftTime.toLocaleTimeString('de', { hour: "2-digit", minute: "2-digit" }) + "-??Uhr"} secondary={" (" + liveShift.location.name + ")"} />
                        </ListItemButton>
                    </ListItem>
                );
            }
        }

        allShifts.forEach((item, index) => {
            const itemDate = new Date(item.start_time);
            const itemEndDate = new Date(item.end_time);
            const monthString = new Date(itemDate.getFullYear(), itemDate.getMonth(), 1).toLocaleDateString('de', { month: 'long', year: 'numeric' });
            const localDateString = itemDate.toLocaleDateString('de', { year: "numeric", month: "2-digit", day: "2-digit" });
            const startTime = itemDate.toLocaleTimeString('de', { hour: "2-digit", minute: "2-digit" });
            let endTime;
            if (item.end_time !== null){
                endTime = itemEndDate.toLocaleTimeString('de', { hour: "2-digit", minute: "2-digit" });
            } else {
                endTime = "???"
            }
            const ignored = item.is_ignored;
           

            if (monthName === monthString) {
                if ((item.duration_working || item.duration_in_pause) === null) {
                    shifts.push(
                        <ListItem className="duration-pause-time" key={index} secondaryAction={matches &&
                            <ListItemText
                                primary={"Arbeit: ???"}
                                secondary={"Pause: ???"}
                            />
                        }>
                            <ListItemButton sx={{ pl: 4 }} component={Link} to={"/home/employees/employeeView/shift?beginId=" + item.shift_begin_activity_id} >
                                <ListItemIcon>
                                    {item.has_unresolved_objections && <img src={process.env.PUBLIC_URL + '/icons/cancel.png'} alt="" width={30} height={30} />}
                                    {!item.has_unresolved_objections && item.shift_status === "completed" && <img src={process.env.PUBLIC_URL + '/icons/ok-green.png'} alt="" width={30} height={30} />}
                                    {!item.has_unresolved_objections && item.shift_status === "not_completed" && <img src={process.env.PUBLIC_URL + '/icons/cancel.png'} alt="" width={30} height={30} />}
                                    {!item.has_unresolved_objections && item.shift_status === "edited_completed" && <img src={process.env.PUBLIC_URL + '/icons/ok-orange.png'} alt="" width={30} height={30} />}
                                    {!item.has_unresolved_objections && item.shift_status === "edited_not_completed" && <img src={process.env.PUBLIC_URL + '/icons/cancel.png'} alt="" width={30} height={30} />}
                                </ListItemIcon>
                                <ListItemText primary={createListItemTextForShifts(localDateString, startTime, endTime, ignored)} secondary={" (" + item.location.name + ")"} />
                            </ListItemButton>
                        </ListItem>
                    );
                } else {
                    shifts.push(
                        <ListItem className="duration-pause-time" key={index} secondaryAction={matches &&
                            <ListItemText
                                primary={"Arbeit: " + createDuration(item.duration_working.hours, item.duration_working.minutes)}
                                secondary={"Pause: " + createDuration(item.duration_in_pause.hours, item.duration_in_pause.minutes)}
                            />
                        }>
                            <ListItemButton sx={{ pl: 4 }} component={Link} to={"/home/employees/employeeView/shift?beginId=" + item.shift_begin_activity_id}>
                                <ListItemIcon>
                                    {item.has_unresolved_objections && <img src={process.env.PUBLIC_URL + '/icons/cancel.png'} alt="" width={30} height={30} />}
                                    {!item.has_unresolved_objections && item.shift_status === "completed" && <img src={process.env.PUBLIC_URL + '/icons/ok-green.png'} alt="" width={30} height={30} />}
                                    {!item.has_unresolved_objections && item.shift_status === "not_completed" && <img src={process.env.PUBLIC_URL + '/icons/cancel.png'} alt="" width={30} height={30} />}
                                    {!item.has_unresolved_objections && item.shift_status === "edited_completed" && <img src={process.env.PUBLIC_URL + '/icons/ok-orange.png'} alt="" width={30} height={30} />}
                                    {!item.has_unresolved_objections && item.shift_status === "edited_not_completed" && <img src={process.env.PUBLIC_URL + '/icons/cancel.png'} alt="" width={30} height={30} />}
                                </ListItemIcon>
                                <ListItemText primary={createListItemTextForShifts(localDateString, startTime, endTime, ignored)} secondary={" (" + item.location.name + ")"} />
                            </ListItemButton>
                        </ListItem>
                    );
                }
            }
        });
    
        if (shifts.length === 0) {
            shifts.push(
                <ListItemText key={monthName} sx={{ pl: 4 }} secondary={"Noch keine Arbeitszeiten"} />
            );
        }
    
        return shifts;
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway')
            return;

        setShowSuccessSnackbar(false);
    }

    function createSuccessfulSnackBar() {
        return (
            <Snackbar open={showSuccessSnackbar} autoHideDuration={6000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'center'}}>
                <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
                    Arbeitszeit wurde erfolgreich erstellt!
                </Alert>
            </Snackbar>
        )
    }

    function createProblemMonthsList() {
        const problemMonths = [];
        problemMonths.push(
            <p key={100}>Folgende Monate haben unvollständige Arbeitszeiten:</p>
        )
        problemShifts.forEach((item, index) => {
            const shiftDate = new Date(item.printableDate)
            const shiftDateString = shiftDate.toLocaleDateString('de', {month: 'long', year: 'numeric'})
            problemMonths.push(
                <p key={index}>{shiftDateString}</p>
            )
        })
        return problemMonths;
    }

    const handleDatePickerOnSelect = (value) => {
        if (!value || isFutureMonth(value)) return;
        setSelectedMonth(value);
        localStorage.setItem("selectedMonthShift", value)
    }

    const handleTodayClick = () =>  {
        const newDay = new Date();
        setSelectedMonth(newDay);
        localStorage.setItem("selectedMonthShift", newDay)
    }

    if (isLoading) {
        return (<LoadingSpinner/>);
    } else {
        return (
            <>
                <ScrollRecovery setCondition={!isLoading} scrollKey={"shiftOverviewScroll"}/>
                {createSuccessfulSnackBar()}
                <CreateShiftModal 
                    modalShow={creationModalShow}  
                    modalShowClose={() => setCreationModalShow(false)}
                    reloadPage={() => setIsLoading(true)}
                    successSnackbar={() => setShowSuccessSnackbar(true)}
                />
                <div className="shifts-overview-container-header">
                    <OverlayTrigger placement="top" overlay={<Tooltip id="button-tooltip">Neue Arbeitszeit nachtragen</Tooltip>}>
                    <Fab color="primary" aria-label="add" onClick={() => setCreationModalShow(true)} className="add-mui-icon" style={{ backgroundColor: 'var(--tictrack-secondary-color)' }}>
                        <AddIcon />
                    </Fab>
                    </OverlayTrigger>
                </div>
                <div className="shifts-overview-select">
                    <CustomProvider locale={deDE}>
                        <DatePicker
                            className="dashboard-datepicker"
                            cleanable={false}
                            label="Monat"
                            oneTap
                            required
                            format="MMM yyyy"
                            size="lg"
                            placeholder="Startmonat"
                            value={selectedMonth}
                            onSelect={handleDatePickerOnSelect}
                            disabledDate={isFutureMonth}
                        />
                    </CustomProvider>
                    <PrimaryButton text="Heute" onClick={handleTodayClick} />
                </div>
                {props.shiftIssue && <div className="problem-shift-list">
                    {createProblemMonthsList()}
                </div>}
                <List className="shift-month-list" >
                    {createMonths()}
                </List>
            </>
        )
    }
}
export default ShiftsOverview;